<template>
  <jade-box>
    <div class="flex flex-col gap-3 py-5">
      <div class="px-5">
        <jade-text
          variant="heading-xsmall"
          color="high"
          >{{ $t('transaction.data') }}</jade-text
        >
      </div>
      <jade-list-item
        :label="$t('transaction')"
        :trailing="transactionId"
        compact
      />
      <div class="px-5">
        <jade-divider />
      </div>
      <jade-list-item
        :label="$t('reason')"
        :trailing="reason"
        compact
      />
      <div class="px-5">
        <jade-divider />
      </div>
      <jade-list-item
        :label="$t('amount')"
        :trailing="amount"
        compact
      />
      <div class="px-5">
        <jade-divider />
      </div>
      <jade-list-item
        label="Status"
        compact
      >
        <template #trailing>
          <jade-display-item
            alignment="right"
            :value="{ variant: statusVariant, text: statusLabel }"
          />
        </template>
      </jade-list-item>
      <div class="px-5">
        <jade-divider />
      </div>
      <jade-list-item
        :label="$t('flag')"
        compact
      >
        <template #trailing>
          <jade-brand :use="brandImage" />
        </template>
      </jade-list-item>
      <div class="px-5">
        <jade-divider />
      </div>
      <jade-list-item
        :label="$t('credit-card-number')"
        :trailing="creditCardNumber"
        compact
      />
    </div>
  </jade-box>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  JadeText,
  JadeBox,
  JadeListItem,
  JadeDisplayItem,
  JadeDivider,
  JadeBrand
} from '@jade'
import ChargebackManager from '../../chargeback.manager'

export default {
  name: 'RepresentmentResume',
  components: {
    JadeText,
    JadeBox,
    JadeListItem,
    JadeDisplayItem,
    JadeDivider,
    JadeBrand
  },
  computed: {
    ...mapGetters(['chargeback']),
    transactionId () {
      return this.chargeback.transactionId
    },
    reason () {
      return this.chargeback.chargeback.reasonDescription
    },
    amount () {
      return this.chargeback.transactionalData.amount
    },
    creditCardNumber () {
      const { cardFirstDigits, cardLastDigits } =
        this.chargeback.transactionalData
      return `${cardFirstDigits}** **${cardLastDigits}`
    },
    cardBrand () {
      return this.chargeback.transactionalData.cardBrand
    },
    statusCode () {
      return this.chargeback.status.code
    },
    statusVariant () {
      return ChargebackManager.chargebackStatusBadge(
        this.chargeback.status.code
      )
    },
    statusLabel () {
      return ChargebackManager.chargebackStatusLabel(
        this.chargeback.status.code
      )
    },
    brandImage () {
      return this.cardBrand.toLowerCase()
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "transaction": "Identificador",
      "transaction.data": "Dados da transação",
      "amount": "Valor",
      "reason": "Motivo",
      "flag": "Bandeira",
      "credit-card-number": "Nº do cartão"
  
    },
    "en-US": {
      "transaction": "Identifier",
      "transaction.data": "Transaction data",
      "amount": "Amount",
      "reason": "Reason",
      "flag": "Flag",
      "credit-card-number": "Card number"
    }
  }
  </i18n>
